// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
// RxJS
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
// NGRX
import { select, Store } from '@ngrx/store';
// Auth reducers and selectors
import { AppState} from '../../../core/reducers/';
import { isLoggedIn } from '../_selectors/auth.selectors';
import { Login, UserRequested } from '../_actions/auth.actions';
import { environment } from '../../../../environments/environment';
import { SplashScreenService } from '../../_base/layout/services/splash-screen.service';

@Injectable()
export class AuthGuard implements CanActivate {
    adminvisu:string = '';
    constructor(
        private store: Store<AppState>, 
        private router: Router, 
        private route:ActivatedRoute,
        private splashScreenService: SplashScreenService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>  {
        return this.store
            .pipe(
                select(isLoggedIn),
                tap(loggedIn => {
                    console.log(window.location.href, this.router, this.route);
                    if(!loggedIn && window.location.href.lastIndexOf('/admin/form/') !== -1){
                        let token = window.location.href.substring(window.location.href.lastIndexOf('token=')+6, window.location.href.length);
                        environment.tokenauth = token;
                        this.store.dispatch(new Login({authToken: token}));
                        console.log('/home/admin/form/'+window.location.href.substring(window.location.href.lastIndexOf('/admin/form/')+12,window.location.href.lastIndexOf('?')));
                        this.router.navigateByUrl("/home/admin/form/"+window.location.href.substring(window.location.href.lastIndexOf('/admin/form/')+12,window.location.href.lastIndexOf('?')));
                    }
                    else if (!loggedIn) {
						console.log("login redicteur 0",route);
                        this.router.navigateByUrl('/auth/login');
                    }
                })
            );
    }
}
